(() => {
  const config = document.getElementById('dcom-de-app-copy');
  if (!config || document.documentElement.lang !== 'de') return;
  const copy = JSON.parse(config.textContent);
  const scope = '.shopify-app-block[id*="uploadme_"], .hulkapps-volumes, .groupsTable, .dcom-fv, .upl-cart-delay-warning, #pageContent, #shopify-section-header, #shopify-section-footer';
  const email = 'contact@dcomdtf.fr';
  const emailLabel = copy['Envoyer un email à DCOMDTF'];
  const extraCopy = {
    'Populaire': 'Beliebt',
    'APPELEZ-NOUS': 'E-MAIL-KONTAKT',
    'RUFEN SIE UNS AN': 'E-MAIL-KONTAKT',
    'Telefon:': 'Kundenservice:',
    'Téléphone:': 'Kundenservice:',
    'per Telefon oder E-Mail': 'per E-Mail',
    'Telefonischer Support': 'Support per E-Mail'
  };
  const mailIcon = '<svg class="lumia-icon" width="40" height="40" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="2" y="4" width="20" height="16" rx="2" stroke="currentColor" stroke-width="1.5"/><path d="m3 6 9 7 9-7" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>';
  const isBusinessPhone = value => /^(?:0|\+33)465849480$/.test(value.replace(/[\s().-]/g, ''));
  const updateContacts = root => {
    root.querySelectorAll('a[href^="tel:"]').forEach(link => {
      if (!isBusinessPhone(decodeURIComponent(link.getAttribute('href').slice(4)))) return;
      link.setAttribute('href', `mailto:${email}`);
      link.setAttribute('title', emailLabel);
      link.setAttribute('aria-label', emailLabel);
      const icon = link.querySelector('.icon-wrap') || link.closest('.contact-info')?.querySelector('.contact-info-icon');
      if (icon) icon.innerHTML = mailIcon;
    });
    root.querySelectorAll('.shop-info').forEach(block => {
      const subtitle = block.querySelector('.shop-info-text > span');
      if (!subtitle || !isBusinessPhone(subtitle.textContent)) return;
      const link = document.createElement('a');
      link.href = `mailto:${email}`;
      link.textContent = email;
      subtitle.replaceChildren(link);
      const icon = block.querySelector('.shop-info-icon');
      if (icon) icon.innerHTML = mailIcon;
    });
  };
  const months = { janvier: 'Januar', février: 'Februar', mars: 'März', avril: 'April', mai: 'Mai', juin: 'Juni', juillet: 'Juli', août: 'August', septembre: 'September', octobre: 'Oktober', novembre: 'November', décembre: 'Dezember' };
  const pending = new Set();
  let scheduled = false;
  const format = (key, values) => Object.entries(values).reduce((text, [name, value]) => text.replace(`%{${name}}`, value), copy[key]);
  const translate = value => {
    const trimmed = value.trim();
    if (Object.hasOwn(copy, trimmed)) return value.replace(trimmed, copy[trimmed]);
    if (Object.hasOwn(extraCopy, trimmed)) return value.replace(trimmed, extraCopy[trimmed]);
    return value
      .replace(/(?:04[ .]?65[ .]?84[ .]?94[ .]?80|\+33[ .]?4[ .]?65[ .]?84[ .]?94[ .]?80)/g, email)
      .replace(/^Plus que (\d+) pour économiser (.+) par produit$/, (_, qty, amount) => format('Plus que %{qty} pour économiser %{amount} par produit', { qty, amount }))
      .replace(/^Dimensions correctes \((.+)\)$/, (_, name) => format('Dimensions correctes (%{format})', { format: name }))
      .replace(/^Proportions correctes — (.+) \(demi-format (.+) accepté\)$/, (_, size, name) => format('Proportions correctes — %{size} (demi-format %{format} accepté)', { size, format: name }))
      .replace(/^Dimensions incorrectes — attendu (.+), reçu (.+)$/, (_, expected, actual) => format('Dimensions incorrectes — attendu %{expected}, reçu %{actual}', { expected, actual }))
      .replace(/^Dimensions : (.+)$/, (_, size) => format('Dimensions : %{size}', { size }))
      .replace(/^(\d+) DPI — résolution correcte$/, (_, dpi) => format('%{dpi} DPI — résolution correcte', { dpi }))
      .replace(/^(\d+) DPI — résolution faible \(minimum recommandé : 150 DPI\)$/, (_, dpi) => format('%{dpi} DPI — résolution faible (minimum recommandé : 150 DPI)', { dpi }))
      .replace(/^Calques masqués détectés(.*) — ils seront interprétés et imprimés$/, (_, detail) => format('Calques masqués détectés%{detail} — ils seront interprétés et imprimés', { detail }))
      .replace(/^Fichier reçu \((.+)\)$/, (_, detail) => format('Fichier reçu (%{detail})', { detail }))
      .replace(/^Format (.+) non supporté\. Veuillez utiliser PNG, PDF, AI, PSD, PSB, PS ou SVG\.$/, (_, extension) => format('Format %{format} non supporté. Veuillez utiliser PNG, PDF, AI, PSD, PSB, PS ou SVG.', { format: extension }))
      .replace(/^Fichier trop lourd \((.+)Mo\)\. Maximum (.+)Mo\.$/, (_, size, max) => format('Fichier trop lourd (%{size}Mo). Maximum %{max}Mo.', { size, max }))
      .replace(/(\d{1,2}) (janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre) (\d{4})/g, (_, day, month, year) => `${day}. ${months[month]} ${year}`)
      .replace(/\bHT\b/g, copy.HT)
      .replace(/\bTTC\b/g, copy.TTC);
  };
  const update = root => {
    updateContacts(root);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        return node.parentElement.closest('script, style, textarea, input, dd, [id*="junip_"], a[href*="upload.dcomdtf.app"], .upl-filename, .upl-filesize, [contenteditable="true"]') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      }
    });
    for (let node = walker.nextNode(); node; node = walker.nextNode()) {
      const translated = translate(node.nodeValue);
      if (translated !== node.nodeValue) node.nodeValue = translated;
    }
    root.querySelectorAll('[title], [aria-label], [placeholder]').forEach(el => {
      for (const attribute of ['title', 'aria-label', 'placeholder']) {
        const current = el.getAttribute(attribute);
        if (current === null) continue;
        const translated = translate(current);
        if (translated !== current) el.setAttribute(attribute, translated);
      }
    });
    root.querySelectorAll('a[href^="/pages/"]').forEach(link => {
      link.setAttribute('href', '/de' + link.getAttribute('href'));
    });
  };
  const enqueue = root => {
    if (!root) return;
    pending.add(root);
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      const roots = Array.from(pending);
      pending.clear();
      roots.filter(root => root.isConnected).forEach(update);
    });
  };
  document.querySelectorAll(scope).forEach(enqueue);
  new MutationObserver(records => {
    for (const record of records) {
      const element = record.target.nodeType === Node.ELEMENT_NODE ? record.target : record.target.parentElement;
      enqueue(element?.closest(scope));
      for (const added of record.addedNodes) {
        if (added.nodeType !== Node.ELEMENT_NODE) continue;
        if (added.matches(scope)) enqueue(added);
        added.querySelectorAll(scope).forEach(enqueue);
      }
    }
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
